import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import "jspdf-autotable";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class KeyDates extends React.Component {
  static contextType = FilterContext;

  state = {
    keyDates: [],
    filters: "",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_custom_key_dates", BodyAsFormData(filters))
      .then((res) => {
        this.setState({ keyDates: res.data });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_custom_key_dates",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ keyDates: res.data });
        });
    }
  }

  render() {
    return (
      <div className="widget widgetCustomTab customTabsDesign">
        <div className="container-fluid p-0 aseetContent mapsUl">
          <div className="row">
            <div className="col-lg-6">
              <div className="tabDetails">
                <ul className="detailsUl">
                  <li className="">
                    <span>Sign Date</span>
                    <span>{this.state.keyDates.sign_date}</span>
                  </li>
                  <li>
                    {" "}
                    <span>Lease Commence</span>
                    <span>{this.state.keyDates.lease_commence}</span>
                  </li>
                  <li>
                    {" "}
                    <span>Fee Commence</span>
                    <span>{this.state.keyDates.fee_commence}</span>
                  </li>
                  <li>
                    {" "}
                    <span>Licensee Lock-in</span>
                    <span>{this.state.keyDates.licensee_lockin}</span>
                  </li>
                  <li>
                    {" "}
                    <span>Licensor Lock-in</span>
                    <span>{this.state.keyDates.licensor_lockin}</span>
                  </li>
                  <li>
                    {" "}
                    <span>Lease Expiry</span>
                    <span>{this.state.keyDates.lease_expiry}</span>
                  </li>
                  <li>
                    {" "}
                    <span>Time to Expiry</span>
                    <span>{this.state.keyDates.time_to_expiry}</span>
                  </li>
                  <li>
                    {" "}
                    <span>Time to Lockin</span>
                    <span>{this.state.keyDates.time_to_lockin}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tabDetails">
                <table className="keyDatesTable">
                  <thead>
                    <tr>
                      <th>
                        <span>Lease Analysis</span>
                      </th>
                      <th></th>
                      <th>Market Average</th>
                    </tr>
                    <tr className="h10px"></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Time to Commence</td>
                      <td>{this.state.keyDates.time_to_commence}</td>
                      <td></td>
                    </tr>
                    <tr className="h10px"></tr>
                    <tr>
                      <td>Rent Free Period</td>
                      <td>{this.state.keyDates.rent_free_period}</td>
                      <td className="position-relative">
                        {this.state.keyDates.rent_free_period_average}
                        <FontAwesomeIcon
                          icon={
                            this.state.keyDates.rent_free_period_trend == 1
                              ? faSortUp
                              : faSortDown
                          }
                          className={
                            this.state.keyDates.rent_free_period_trend == 1
                              ? "faColorUp"
                              : "faDownRed"
                          }
                          size="lg"
                        />
                      </td>
                    </tr>
                    <tr className="h10px"></tr>
                    <tr>
                      <td>Licensee Lock-in Period</td>
                      <td>{this.state.keyDates.licensee_lockin_period}</td>
                      <td className="position-relative">
                        {this.state.keyDates.licensee_lockin_period_average}
                        <FontAwesomeIcon
                          icon={
                            this.state.keyDates.licensee_lockin_period_trend ==
                            1
                              ? faSortUp
                              : faSortDown
                          }
                          className={
                            this.state.keyDates.licensee_lockin_period_trend ==
                            1
                              ? "faColorUp"
                              : "faDownRed"
                          }
                          size="lg"
                        />
                      </td>
                    </tr>
                    <tr className="h10px"></tr>
                    <tr>
                      <td>Licensor Lock-in Period</td>
                      <td>{this.state.keyDates.licensor_lockin_period}</td>
                      <td className="position-relative">
                        {this.state.keyDates.licensor_lockin_period_average}
                        <FontAwesomeIcon
                          icon={
                            this.state.keyDates.licensor_lockin_period_trend ==
                            1
                              ? faSortUp
                              : faSortDown
                          }
                          className={
                            this.state.keyDates.licensor_lockin_period_trend ==
                            1
                              ? "faColorUp"
                              : "faDownRed"
                          }
                          size="lg"
                        />
                      </td>
                    </tr>
                    <tr className="h10px"></tr>
                    <tr>
                      <td>Lease Term</td>
                      <td>{this.state.keyDates.lease_term}</td>
                      <td className="position-relative">
                        {this.state.keyDates.lease_term_average}
                        <FontAwesomeIcon
                          icon={
                            this.state.keyDates.rent_free_period_trend == 1
                              ? faSortUp
                              : faSortDown
                          }
                          className={
                            this.state.keyDates.rent_free_period_trend == 1
                              ? "faColorUp"
                              : "faDownRed"
                          }
                          size="lg"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(KeyDates);
